import { render } from "./OVPOReasonModal.vue?vue&type=template&id=4ff7a9ff&ts=true"
import script from "./OVPOReasonModal.vue?vue&type=script&lang=ts"
export * from "./OVPOReasonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__